import IFrameResizer from "iframe-resizer";
const { iframeResizer } = IFrameResizer;

// URLs that do not use the iframe-resizer module
// reduces number of console warnings
// allows third-party vendors to still provide resizeable embeds
export const resizeBlacklist = [
  "cdn.embedly.com",
  "player.vimeo.com",
  "www.youtube.com",
  "datawrapper.dwcdn.net",
  "w.soundcloud.com",
  "player.megaphone.fm",
];

export function resizeIFrame(iframe: HTMLIFrameElement) {
  const hostname = new URL(iframe.src).hostname;
  // only run if the hostname does not match a list of non-resizeable iframes
  if (resizeBlacklist.indexOf(hostname) === -1) {
    iframeResizer(
      {
        checkOrigin: false,
        // TODO: update library's types to rename resizedCallback >> onResized
        resizedCallback({ iframe, width, height }) {
          const parent = iframe.parentElement;
          if (parent?.classList.contains("embed-wrapper")) {
            const padding = 100 * (+height / +width);
            parent.style.paddingBottom = `${padding}%`;
          }
        },
      },
      iframe
    );
  }
}
